<ion-content>
  <div class="centered-card">
    <ion-button
      class="btn-large"
      fill="clear"
      shape="round"
      (click)="goBack()"
      style="margin: 5px"
      *ngIf="fullRedirect"
    >
      <ion-icon name="arrow-back-outline" class="padded-icon"></ion-icon>
      Back to dashboard
    </ion-button>

    <ion-grid>
      <ion-row>
        <ion-col size="12" size-md="4">
          <ion-card>
            <img [src]="integration.imageSrc" />
            <ion-card-header class="shown-md">
              <ion-card-title>{{integration.name}}</ion-card-title>
            </ion-card-header>
            <ion-card-content>
              <div *ngIf="integrationType === 'outlook' && !isEnabled">
                <span class="input-label"> Client ID </span>
                <ion-input
                  placeholder="e.g. 'cfe601d3-e4d3-4bfa-9735-ee70673a23bf'"
                  [(ngModel)]="clientId"
                  class="input-field"
                >
                </ion-input>
                <span class="input-label"> Client Secret </span>
                <ion-input placeholder="Client secret" [(ngModel)]="clientSecret" class="input-field"> </ion-input>
                <span class="input-label"> Directory (tenant) ID </span>
                <ion-input
                  placeholder="e.g. '3771ef65-79bb-41e6-8427-6d617ce4d9ba'"
                  [(ngModel)]="directoryId"
                  class="input-field"
                >
                </ion-input>
              </div>

              <ion-buttons slot="end" class="org-select-container" *ngIf="integrationType === 'slack'">
                <ng-container *ngIf="organizers && organizers.length">
                  <span>Select a community: </span>
                  <ion-chip (click)="changeOrg()" outline="true" color="primary">
                    {{organizer.name}}
                    <ion-icon name="caret-down-outline"></ion-icon>
                  </ion-chip>
                </ng-container>
                <span *ngIf="!organizers || !organizers.length"
                  ><i>No communities exist. Please create a community and return here to connect it to Slack.</i></span
                >
              </ion-buttons>
            </ion-card-content>
            <div class="buttons">
              <ion-button [disabled]="true" *ngIf="code || isLoading">
                <ion-spinner name="crescent"></ion-spinner>
                <span>Connecting</span>
              </ion-button>
              <ion-button
                (click)="connect()"
                *ngIf="
                !isEnabled && !code && !isLoading && (integrationType === 'zoom' || integrationType === 'outlook' || integrationType === 'teams' || integrationType === 'directory-sync')
              "
              >
                {{integration.connect}}
              </ion-button>
              <div *ngIf="!isEnabled && integrationType === 'slack' && organizers && organizers.length">
                <a (click)="connect()" *ngIf="authService.user">
                  <img
                    alt="Add to Slack"
                    height="40"
                    width="139"
                    src="https://platform.slack-edge.com/img/add_to_slack.png"
                    srcset="
                      https://platform.slack-edge.com/img/add_to_slack.png    1x,
                      https://platform.slack-edge.com/img/add_to_slack@2x.png 2x
                    "
                  />
                </a>
                <ion-button (click)="connect()" *ngIf="!authService.user">
                  <ion-icon name="enter-outline" class="padded-icon"></ion-icon>
                  Login to enable this app
                </ion-button>
              </div>

              <ion-button [disabled]="true" *ngIf="isEnabled" color="success">
                <ion-icon name="checkmark"></ion-icon>
                Connected
              </ion-button>
            </div>
            <div class="error" *ngIf="errorMessage">{{errorMessage}}</div>
          </ion-card>
        </ion-col>
        <ion-col size="12" size-md="8">
          <ion-card style="padding: 20px">
            <ion-card-header class="hidden-md">
              <ion-card-title style="font-size: 1.5rem">{{integration.title}}</ion-card-title>
            </ion-card-header>
            <!-- <ion-card-content [innerHTML]="integration.html">
            </ion-card-content> -->
            <ion-card-content> {{integration.preview}} </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>

    <div style="text-align: center; font-size: 0.8rem; margin-top: 30px" *ngIf="integrationType === 'slack'">
      <a (click)="viewPrivacyPolicy()">Privacy policy</a>
    </div>
  </div>
</ion-content>
